var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 160,
    viewBox: "0 0 146 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2376 124.571V142.857C61.7701 142.857 54.0947 150.533 54.0947 160H88.3804V124.571H71.2376Z",
    fill: "#FF9811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0949 28.5714H17.1429C7.67543 28.5714 0 36.2469 0 45.7143H34.0949V28.5714Z",
    fill: "#FF9811"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0949 62.8571H88.3806V31.4286C88.3806 14.0714 74.3097 0 56.952 0C39.5949 0 25.5234 14.0714 25.5234 31.4286V62.8571V77.1429C25.5234 82.0737 25.5234 87.9594 25.5234 94.2857C25.5234 111.643 39.5943 125.714 56.952 125.714H128.381C128.381 125.714 128.381 111.643 128.381 94.2857C128.381 76.928 111.453 62.8571 94.0949 62.8571Z",
    fill: "#9DD7F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0942 62.8571H88.3799V125.714H128.38C128.38 125.714 128.38 111.643 128.38 94.2857C128.38 76.928 111.452 62.8571 94.0942 62.8571Z",
    fill: "#78B9EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0942 40C57.2501 40 59.8085 37.4416 59.8085 34.2857C59.8085 31.1298 57.2501 28.5714 54.0942 28.5714C50.9383 28.5714 48.3799 31.1298 48.3799 34.2857C48.3799 37.4416 50.9383 40 54.0942 40Z",
    fill: "#001B3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.523 62.8571C145.523 84.9486 127.615 102.857 105.523 102.857C83.432 102.857 65.5234 84.9486 65.5234 62.8571C88.3806 62.8571 99.8092 62.8571 145.523 62.8571Z",
    fill: "#006DF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.641bfdf67f7e58ac97d1ac0cee081404.svg";
export { ForwardRef as ReactComponent };